import { imagePicker } from '@utils/imagePicker';
import React from 'react';
import { ImageFromDirectus } from '..';
import { ProjectCardProps } from './ProjectCardProps';
import * as styles from './ProjectCard.module.scss';
import classNames from 'classnames';

export const ProjectCard: React.FC<ProjectCardProps> = ({
	subDescription,
	title,
	description,
	goals,
	value,
	subsidy,
	img,
}) => {
	return (
		<div className={styles.splideSlide}>
			<div className={styles.innerContent}>
				<div className={styles.innerBox}>
					<p className={styles.innerSub}>{subDescription}</p>
					<h2>{title}</h2>
				</div>
				<div className={styles.innerBox}>
					<p className={styles.innerTitle}>Cele projektu:</p>
					<p>{description}</p>
				</div>
				{goals && (
					<div className={styles.innerBox}>
						<p className={styles.innerTitle}>Planowane efekty:</p>
						<p>{goals}</p>
					</div>
				)}
				<div className={styles.projectValue}>
					{value && (
						<div>
							<p className={classNames(styles.innerTitle, styles.value)}>
								Wartość projektu:
							</p>
							<p>{value}</p>
						</div>
					)}
					{subsidy && (
						<div>
							<p className={classNames(styles.innerTitle, styles.value)}>
								Wartość dofinansowania:
							</p>
							<p>{subsidy}</p>
						</div>
					)}
				</div>
				{img && (
					<div className={styles.sponsors}>
						<ImageFromDirectus
							image={imagePicker(img)}
							alt={title}
							imageClassName={styles.sponsors}
						/>
					</div>
				)}
			</div>
		</div>
	);
};
